import { EnvironmentValuesEnum } from '../constants';

export const getApimPublicOcpKey = (environment: string): string => {
  switch (environment) {
    case EnvironmentValuesEnum.Local:
      return '1cd2b0e48d3c4c3e82374a652701a268';
    case EnvironmentValuesEnum.Development:
      return '1cd2b0e48d3c4c3e82374a652701a268';
    case EnvironmentValuesEnum.Quality:
      return 'd184e3a8124a45e08706bdf64c20f028';
    case EnvironmentValuesEnum.Acceptance:
      return '3fe9c46a262d4a0b9215dfc5bed8cb29';
    case EnvironmentValuesEnum.Hypercare:
      return '14b3dff5e9e943ee8675214b106079d2';
    case EnvironmentValuesEnum.Production:
      return '9f0a6ae0bc804952a403c886b6ffed9a';
    default:
      return '1cd2b0e48d3c4c3e82374a652701a268';
  }
};